export default "__VITE_ASSET__CBHGDB6U__"